import { isNil } from 'lodash';

/**
 * Recursive partial for V2 presenter `placeholder*Data` (list/grid DTOs, BFF hints).
 * TypeScript's `Partial<T>` is shallow only; nested entities (e.g. appointment on asset) need recursion.
 */
export type PresenterPlaceholderData<T> = T extends (infer U)[]
  ? PresenterPlaceholderData<U>[]
  : T extends object
    ? { [K in keyof T]?: PresenterPlaceholderData<T[K]> }
    : T;

/**
 * Boundary cast for DTO rows whose leaf types (e.g. `string` vs enum) do not structurally match the entity type.
 */
export function toPresenterPlaceholder<T>(value: unknown): PresenterPlaceholderData<T> | undefined {
  if (isNil(value)) {
    return undefined;
  }

  return value as PresenterPlaceholderData<T>;
}
